import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CreditModel } from 'common/models/page-models/credits/credit-data-model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { CreditFormWidgetService } from 'common/widget/credit/credit-form-widget.service';

@Injectable({
    providedIn: 'root'
})
export class CreditFormResolver extends FormResolverService<CreditModel> {
    constructor(
        protected fs: CreditFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}
